import { render } from "./VabeneAddCouponPage.vue?vue&type=template&id=36bb8af0&ts=true"
import script from "./VabeneAddCouponPage.vue?vue&type=script&lang=ts"
export * from "./VabeneAddCouponPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__